import request from '@/utils/request'

export function getMenu() {
  return request({
    url: '/menu/allByid',
    method: 'post',
    data: {
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/menu.js